var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"},on:{"dragenter":_vm.dragEnter,"dragleave":_vm.dragLeave,"dragover":function($event){$event.preventDefault();},"drop":_vm.drop}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }